import { FlightCancellationConfig } from '@pv-frontend/flights-cancellation';

import { flightCancellationConfig } from './flights-cancellation';

export interface AllJourneyConfig {
  flightCancellation: FlightCancellationConfig;
}

export const allJourneyDetails: AllJourneyConfig = {
  flightCancellation: flightCancellationConfig,
};
